export const ZOOM_LEVELS = [50, 75, 100, 125, 150, 200] as const;

export type ZoomLevel = (typeof ZOOM_LEVELS)[number];
